import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import React, { Component } from "react";
import { enableRtl } from "@syncfusion/ej2-base";
import { Button, Spinner, Form } from "react-bootstrap";
// import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";
import NumberFormat from "react-number-format";
import { Query } from "@syncfusion/ej2-data";
import { Redirect } from "react-router-dom";
import dateicon from "../assets/dateicon.png";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

enableRtl(true);

export default class AdvanceRight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chashchange: "",
      selectedSymbol: null,
      selectedSymbol1: null,
      selectedBasket: null,
      selectedBroker: "",
      quantitychange: "",
      brokercheck: false,
      dateValue: moment().format("jYYYY/jMM/jDD"),
      basketValue: "",
      brokerValue: "",
      Redirect: false,
      dateErrorText: "",
      symbolErrorText: "",
      symbol1ErrorText: "",
      quantityErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      symbol1False: false,
      quantityFalse: false,
      basketFalse: false,
      brokerFalse: false,
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      options: [],
      isLoading: false,
      currenttseid: "",
      symbolIsSelected: false,
      selectedSymbolId: null,
      symbol: "",
      buttonDisabled: false,
      isEdit: null,
    };

    this.fields = { value: "full_name" };
    this.fields1 = { value: "lable" };
    this.fields2 = { value: "full_name" };

    this.query = new Query().where("type_code", "equal", 7);
    this.query1 = new Query().where("type_code", "notequal", 7);

    this.quantitychange = this.quantitychange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.getSymbol = this.getSymbol.bind(this);

    this.datepickerr = React.createRef();
  }

  // searchSymbol(query){
  //     this.setState({isLoading:true})
  //     let data = {
  //         mobile: localStorage.getItem("mobile"),
  //         token:localStorage.getItem("token"),
  //         word:query,
  //         type:'right'
  //     };

  //     fetch("/api/searchSymbol",{
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify(data)
  //     })
  //     .then(res => res.json())
  //     .then(
  //     (resultt) => {
  //         if (resultt.status===200){
  //             this.setState({options:resultt.result,isLoading:false})
  //         }else{
  //             this.props.history.push('/Login');
  //         }
  //     }
  //     )
  // }

  componentDidMount() {
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length < 2
    ) {
      this.setBrokerValue(this.props.userBrokersData[0].full_name, true);
    }

    if (this.props.userBasketsData.length < 2) {
      this.setBasketValue(this.props.userBasketsData[0].lable, true);
    }
  }

  getSymbol(query, id) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result }, () => {
            resultt.result.forEach((element) => {
              if (element.id === id) {
                let s = [];
                s.push(element);
                this.setState(
                  { selectedSymbol: element, selectedSymbol1: s },
                  () => {
                    this.searchForRealSymbol(
                      this.state.selectedSymbol.symbol
                        .substring(
                          0,
                          this.state.selectedSymbol.symbol.length - 1
                        )
                        .trim()
                    );
                  }
                );
              }
            });
            this.setState({ isLoading: false });
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  searchSymbolH(query) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "right",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result, isLoading: false });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    try {
      if (prevProps.userBasketsData !== this.props.userBasketsData) {
        if (this.props.userBasketsData.length > 1) {
          this.acBaskets.readonly = false;
        } else {
          this.acBaskets.readonly = true;
        }
      }

      if (this.state.brokercheck) {
        if (prevProps.userBrokersData !== this.props.userBrokersData) {
          if (this.props.userBrokersData.length > 1) {
            this.acBrokers.readonly = false;
          } else {
            this.acBrokers.readonly = true;
          }
        }
      }

      if (
        prevState.selectedSymbol !== null &&
        this.state.selectedSymbol === null
      ) {
        this.setState({
          symbolIsSelected: false,
          symbol: "",
          selectedSymbolId: null,
        });
      }
    } catch (error) {}
  }

  SubmitFrom() {
    try {
      let selectbasket = this.acBaskets.value;
      let selectbroker;
      if (this.state.brokercheck) {
        selectbroker = this.acBrokers.value;
      }
      // let date=this.convertDate(this.state.dateValue);
      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let symbolid;
      if (this.state.selectedSymbol !== null)
        symbolid = this.state.selectedSymbol.id;
      let brokerid;
      let basketid;
      // let type;
      // this.props.symbolsData.forEach(function(entry) {
      //     if (entry.full_name===selectsymbol){
      //         symbolid=entry.id;
      //     }
      // });

      // this.props.symbolsData.forEach(function(entry) {
      //     if (entry.full_name===selectsymbol1){
      //         symbolid1=entry.id;
      //     }
      // });

      this.props.userBasketsData.forEach(function (entry) {
        if (entry.lable === selectbasket) {
          basketid = entry.id;
        }
      });

      if (this.state.brokercheck) {
        this.props.userBrokersData.forEach(function (entry) {
          if (entry.full_name === selectbroker) {
            brokerid = entry.id;
          }
        });
      }

      let fromm;
      if (this.state.brokercheck) {
        fromm = "broker";
      } else {
        fromm = "bank";
        brokerid = null;
      }

      let quantity = this.state.quantitychange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      let indexofelement = 3;
      if (this.props.isPopup) indexofelement = 0;
      if (this.state.selectedSymbol === null) {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid var(--red1)";
        this.setState({
          symbolFalse: true,
          symbolErrorText: "نام نماد باید وارد شود",
        });
        return;
      } else {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid #ced4da";
        this.setState({ symbolFalse: false, symbolErrorText: "" });
      }
      if (quantity === "") {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نامعتبر است",
        });
        return;
      } else if (Number(quantity) < 1) {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ quantityFalse: false, quantityErrorText: "" });
      }
      if (
        this.acBaskets.value === null ||
        this.acBaskets.value === "" ||
        basketid === undefined
      ) {
        this.setState({
          basketFalse: true,
          basketErrorText: "نام سبد نامعتبر است",
        });
        return;
      } else {
        this.setState({ basketFalse: false, basketErrorText: "" });
      }
      if (
        this.state.brokercheck &&
        (this.acBrokers.value === null ||
          this.acBrokers.value === "" ||
          brokerid === undefined)
      ) {
        this.setState({
          brokerFalse: true,
          brokerErrorText: "نام کارگزاری نامعتبر است",
        });
        return;
      } else {
        this.setState({ brokerFalse: false, brokerErrorText: "" });
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        right_id: symbolid,
        broker_id: brokerid,
        basket_id: basketid,
        dscr: "",
        date: date,
        symbol_id: this.state.selectedSymbolId,
        quantity_change: quantity,
        from: fromm,
        type: "convertStockRights",
      };

      if (this.state.isEdit) {
        this.editAction(data, brokerid, basketid);
        return;
      }

      this.setState({ buttonDisabled: true });
      fetch("/api/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.onRefresh();
            this.resetForm();

            toast.success("سند مورد نظر با موفقیت ثبت گردید", {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }

          this.setState({ buttonDisabled: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false });
    }
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue: value });
  }

  acSymbolChange(item) {
    // let currentvalue=this.acSymbol1.value
    // let name="";
    //     let fullname=null
    //     this.props.symbolsData.forEach(function(entry) {
    //         if (entry.full_name===currentvalue){
    //             name=entry.symbol.substring(0, entry.symbol.length - 1);
    //         }
    //     });

    //     this.props.symbolsData.forEach(function(entry) {
    //         if (entry.symbol===name){
    //             fullname=entry.full_name;
    //         }
    //     });
    //     this.acSymbol.value=fullname

    // this.setState({selectedSymbol1:this.acSymbol1.value});
    try {
      if (item.length < 1) {
        this.setState({
          selectedSymbol: null,
          symbolIsSelected: false,
          symbol: "",
          selectedSymbolId: null,
          selectedSymbol1: null,
        });
        return;
      }
      let s = [];
      s.push(item[0]);
      this.setState({ selectedSymbol: item[0], selectedSymbol1: s }, () => {
        if (this.state.selectedSymbol !== null) {
          this.searchForRealSymbol(
            this.state.selectedSymbol.symbol
              .substring(0, this.state.selectedSymbol.symbol.length - 1)
              .trim()
          );
        }
      });
    } catch (error) {}
  }

  searchForRealSymbol(value) {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: value,
      type: "all",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({
            symbol: resultt.result[0].symbol,
            selectedSymbolId: resultt.result[0].id,
            symbolIsSelected: true,
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  // acSymbolChange1(){
  //     this.setState({selectedSymbol1:this.acSymbol1.value});
  // }

  acBasketChange() {
    this.setState({ selectedBasket: this.acBaskets.value });
  }

  acBrokerChange() {
    this.setState({ selectedBroker: this.acBrokers.value });
  }

  quantitychange(event) {
    this.setState({ quantitychange: event.target.value });
  }

  radioBrokerChange() {
    if (this.radioBroker.checked) {
      this.setState({ brokercheck: true });
    }
  }

  radioAccountChange() {
    if (!this.radioBroker.checked) {
      this.setState({ brokercheck: false });
    }
  }

  setBasketValue(name, readonly) {
    try {
      this.acBaskets.value = name;
      this.acBaskets.readonly = readonly;
    } catch (error) {}
  }

  setBrokerValue(name, readonly) {
    if (this.state.brokercheck) {
      this.acBrokers.value = name;
      this.acBrokers.readonly = readonly;
    }
  }

  itemTemplate(data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>{data.broker_name}</div>
        {data.lable !== null &&
          data.lable !== "" &&
          data.lable !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--gray1)" }}>
              {data.lable}
            </div>
          )}
      </div>
    );
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    // if (this.props.isPopup){
    //     this.props.cancelForm();
    //     return;
    // }
    this.setState({
      quantitychange: "",
      selectedSymbol: null,
      symbolIsSelected: false,
      symbol: "",
      selectedSymbolId: null,
      selectedSymbol1: null,
      isEdit: null,
      dateErrorText: "",
      symbolErrorText: "",
      symbol1ErrorText: "",
      quantityErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      symbol1False: false,
      quantityFalse: false,
      basketFalse: false,
      brokerFalse: false,
    });
    document.querySelectorAll(".rbt-input-main")[3].style.border =
      "1px solid #ced4da";
    this.acSymbol1.clear();
    if (
      this.props.selectedPortfolioId === 0 &&
      this.props.userBasketsData.length > 1
    ) {
      this.acBaskets.value = "";
    }
    if (
      this.state.brokercheck &&
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length > 1
    ) {
      this.acBrokers.value = "";
    }
  }

  editFrom(data) {
    if (data.broker_id !== null) {
      this.setState({ brokercheck: true }, () => {
        this.radioBroker.checked = true;
        if (this.props.userBrokersData.length > 1) {
          if (data.lable !== null && data.lable !== "") {
            this.acBrokers.value = data.broker + " (" + data.lable + ")";
          } else {
            this.acBrokers.value = data.broker;
          }
        }
      });
    } else {
      this.setState({ brokercheck: false });
      this.radioAccount.checked = true;
    }

    this.setState(
      {
        quantitychange: Math.abs(data.quantity),
        dateValue: moment(data.date, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD"),
      },
      () => {
        if (this.props.userBasketsData.length > 1) {
          this.acBaskets.value = data.basket;
        }
      }
    );

    this.getSymbol(data.symbol, data.symbol_id);
    this.setState({ isEdit: data });

    // if (data.broker_id!==null){
    //     this.getSymbol(data.symbol+"ح")
    //     this.setState({isEdit:data})
    // }else{
    //     this.getSymbol(data.symbol)
    //     this.setState({isEdit:data})
    // }
  }

  editAction(body, brokerid, basketid) {
    let data = body;

    let d = [];
    if (this.state.isEdit.child === undefined) {
      d.push(this.state.isEdit);
    } else {
      this.state.isEdit.child.forEach((element) => {
        d.push(element);
      });
    }
    data.list = d;

    this.setState({ buttonDisabled: true });
    fetch("/api/editTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.props.onRefresh();

          this.resetForm();
          toast.success("سند با موفقیت ویرایش شد", {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (resultt.status === 401) {
          this.setState({ Redirect: true });
        } else {
          toast.error(resultt.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false });
      });
  }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    return (
      <div className="contentStyle">
        <div id="componentsParent" style={{ minHeight: "340px" }}>
          {/* <div style={{width:'100%'}}>
                        <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRedDate":"form-control inputStyleFormDate"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        />
                    </div> */}
          <div className="InputWithIcon" style={{ direction: "ltr" }}>
            <div className="inputImageDiv">
              <img src={dateicon} className="inputImage" alt="date" />
            </div>
            {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        /> */}
            <DatePicker
              ref={this.datepickerr}
              value={this.state.dateValue}
              inputClass={
                this.state.dateFalse
                  ? "form-control inputStyleRed"
                  : "form-control inputStyleForm"
              }
              calendar="persian"
              locale="fa"
              weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
              format="YYYY/MM/DD"
              animation
              className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
              onChange={(valuee) => this.dateChange(valuee)}
              maxDate={this.state.maxDateStart}
              editable={false}
              inputMode="none"
              fixMainPosition={true}
              fixRelativePosition={true}
              placeholder="تاریخ"
            />
          </div>
          <div className="errorMessage1">{this.state.dateErrorText}</div>
          {/* <AutoCompleteComponent className={this.state.symbol1False ? "inputStyleRed":"inputStyleForm"} change={this.acSymbol1Change.bind(this)} query={this.query} ref={(scope) => this.acSymbol1 = scope} enableRtl='true' noRecordsTemplate="موردی یافت نشد" allowCustom={false} filterType="Contains" popupHeight="550px" dataSource={this.props.symbolsData} fields={this.fields} placeholder="نماد حق تقدم" autofill={true} /> */}
          <AsyncTypeahead
            id="symbolAuto"
            searchText="در حال جستجو..."
            promptText="لطفاً نام نماد حق تقدم مورد نظر را تایپ کنید"
            paginationText="نمایش موارد بیشتر ..."
            useCache={true}
            ref={(scope) => (this.acSymbol1 = scope)}
            isLoading={this.state.isLoading}
            labelKey="full_name"
            minLength={2}
            onSearch={this.searchSymbolH.bind(this)}
            onInputChange={(text) => {
              if (
                text === "" ||
                (this.state.selectedSymbol !== null &&
                  text !== this.state.selectedSymbol.full_name)
              )
                this.setState({
                  selectedSymbol: null,
                  symbolIsSelected: false,
                  symbol: "",
                  selectedSymbolId: null,
                  selectedSymbol1: null,
                });
            }}
            options={this.state.options}
            placeholder="نماد حق تقدم"
            delay={100}
            emptyLabel="موردی یافت نشد"
            flip={true}
            clearButton={true}
            onChange={this.acSymbolChange.bind(this)}
            selected={this.state.selectedSymbol1}
          />

          <div className="errorMessage1">{this.state.symbolErrorText}</div>

          {this.state.symbolIsSelected && (
            <Form.Control
              className="form-control inputStyleForm inputStyleFormInput"
              placeholder="نماد"
              type="text"
              value={this.state.symbol}
              disabled={true}
            />
          )}

          {/* <div className="errorMessage1">{this.state.symbolErrorText}</div> */}

          <NumberFormat
            placeholder="تعداد"
            className={
              this.state.quantityFalse
                ? "form-control inputStyleRed"
                : "form-control inputStyleForm"
            }
            displayType={"input"}
            thousandSeparator={true}
            onChange={this.quantitychange}
            value={this.state.quantitychange}
          />
          <div className="errorMessage1">{this.state.quantityErrorText}</div>

          <AutoCompleteComponent
            showPopupButton={true}
            className={
              this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
            }
            ref={(scope) => (this.acBaskets = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBasketsData}
            fields={this.fields1}
            placeholder="سبد"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.basketErrorText}</div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "flex-start",
              fontSize: "13px",
              color: "var(--textcolor1)",
              flexWrap: "wrap",
            }}
          >
            <div>آورده نقدی تبدیل سهم از طریق:</div>
            <div style={{ width: "25px" }} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "10px",
              }}
            >
              <RadioButtonComponent
                label="کارگزاری"
                ref={(scope) => (this.radioBroker = scope)}
                change={this.radioBrokerChange.bind(this)}
                enableRtl="true"
                name="type"
              />
              <div style={{ width: "25px" }} />
              <RadioButtonComponent
                label="حساب بانکی"
                ref={(scope) => (this.radioAccount = scope)}
                enableRtl="true"
                name="type"
                change={this.radioAccountChange.bind(this)}
                checked={true}
              />
            </div>
          </div>
          {this.state.brokercheck && (
            <AutoCompleteComponent
              itemTemplate={this.itemTemplate}
              showPopupButton={true}
              className={
                this.state.brokerFalse ? "inputStyleRed" : "inputStyleForm"
              }
              ref={(scope) => (this.acBrokers = scope)}
              filterType="Contains"
              enableRtl="true"
              noRecordsTemplate="موردی یافت نشد"
              popupHeight="550px"
              dataSource={this.props.userBrokersData}
              fields={this.fields2}
              placeholder="کارگزاری"
              autofill={true}
            />
          )}
          {this.state.brokercheck && (
            <div className="errorMessage1">{this.state.brokerErrorText}</div>
          )}

          {/* <Button variant="secondary" style={{width:'50%',fontSize:'13px',marginTop:'20px',height:'30px'}} onClick={this.SubmitFrom.bind(this)}>ثبت</Button> */}
          {!this.state.isEdit && !this.props.isPopup && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabled}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonDisabled && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonDisabled && <div>ثبت</div>}
            </Button>
          )}
          {(this.state.isEdit || this.props.isPopup) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              <Button
                variant={this.state.isEdit ? "primary" : "secondary"}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                disabled={this.state.buttonDisabled}
                onClick={this.SubmitFrom.bind(this)}
              >
                {this.state.buttonDisabled && (
                  <Spinner className="spinnerStyle" animation="border" />
                )}
                {!this.state.buttonDisabled && this.state.isEdit && (
                  <div>ویرایش</div>
                )}
                {!this.state.buttonDisabled && !this.state.isEdit && (
                  <div>ثبت&nbsp;{this.state.buttonTitle}</div>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
